const codingTemplateEs = {
  coding_template: "Plantilla de Codificación",
  coding_templates: "Plantillas de Codificación",
  add_coding_template: "Agregar Plantilla de Codificación",
  edit_coding_template: "Editar Plantilla de Codificación",
  name: "Nombre",
  description: "Descripción",
  actions: "Acciones",
  supplier: "Proveedor",
  supplier_name: "Nombre del proveedor",
  select_supplier: "Seleccionar proveedor",
  select_dimension_value: "Seleccionar valor",
  default: "Predeterminada",
  allocations: "Asignaciones",
  add_allocation: "Agregar Asignación",
  percentage: "Porcentaje",
  cancel: "Cancelar",
  save: "Guardar",
  add: "Agregar",
  update: "Actualizar",
  something_went_wrong: "Algo salió mal",
  no_coding_templates_found: "No se encontraron plantillas de codificación",
  service_invoice_tags: "Etiquetas de factura del Servicio",
  supplier_service_tags_not_defined: "No hay etiquetas de servicio definidas para este proveedor.",
  coding_template_supplier_hint:
    "Si no se selecciona un proveedor, esta plantilla se usará como la Plantilla Predeterminada de tu organización.",
  coding_template_allocations_description:
    "Divide el monto de la factura entre dimensiones. Los porcentajes de todas las asignaciones deben sumar 100.",
  coding_template_name_required: "El nombre es obligatorio",
  coding_template_description_max_length:
    "La descripción debe tener como máximo 500 caracteres",
  coding_template_percentage_required: "El porcentaje es obligatorio",
  coding_template_percentage_range: "El porcentaje debe estar entre 0 y 100",
  coding_template_allocation_required: "Se requiere al menos una asignación",
  coding_template_dimension_required:
    "Seleccione al menos un valor de dimensión de cuenta GL para esta asignación.",
  coding_template_percentage_sum_error:
    "La suma de todos los porcentajes de asignación debe ser igual a 100",
  coding_template_created_successfully:
    "Plantilla de codificación creada exitosamente",
  coding_template_updated_successfully:
    "Plantilla de codificación actualizada exitosamente",
  coding_template_deleted_successfully:
    "Plantilla de codificación eliminada exitosamente",
  delete_coding_template_title: "Eliminar Plantilla de Codificación",
  delete_coding_template_description:
    "¿Estás seguro de que deseas eliminar esta plantilla de codificación?",
  glaccount_dimension_not_configured:
    "La dimensión de la cuenta de mayor no ha sido configurada",
  accrual_period: "Período de acumulación",
  coding_template_accrual_period_range:
    "El período de acumulación debe estar entre 1 y 12",
  coding_template_accrual_period_hint:
    "El período de acumulación se basa en meses y su valor debe estar entre 1 y 12",
  config: "Configuración",
  config_hint:
    "Por defecto, la plantilla de codificación se divide en Total sin impuestos, pero puedes cambiarlo desde aquí.",
  enable_split_on_total_amount: "Habilitar división en cantidad total",
  config_subtitle: "Elige dónde se aplican los porcentajes de asignación.",
  split_on: "Dividir en",
  split_on_invoice_total: "Total de la factura",
  split_on_tax_line: "Cada línea de impuesto",
  split_on_tax_line_hint:
    "Los porcentajes de distribución se aplican por separado a cada línea de impuestos de la tabla de impuestos (su base imponible y su impuesto), de modo que cada tipo impositivo se distribuye entre las mismas dimensiones.",
};

export default codingTemplateEs;
